import { createStore } from 'zustand'
import { devtools } from 'zustand/middleware'
import type { SearchStoreState } from './types'
import { trackingMiddleware } from './middleware/Tracking'
import {
  createProductsSlice,
  createFiltersSlice,
  createContextSlice,
  createSharedSlice,
} from './slices'

export const createSearchStore = (
  initialState: Partial<SearchStoreState> | undefined,
) => {
  return createStore<SearchStoreState>()(
    devtools(
      trackingMiddleware((set, get, api) => ({
        ...createSharedSlice(set, get, api),
        ...createContextSlice(set, get, api),
        ...createFiltersSlice(set, get, api),
        ...createProductsSlice(set, get, api),
        ...initialState,
      })),
    ),
  )
}
